import { makeStyles, tokens } from '@fluentui/react-components';

export const useNewReportDialogActionStyles = makeStyles({
    control: {
        maxWidth: '100%',
    },
    errorMessage: {
        color: tokens.colorStatusDangerForeground3,
        marginTop: '8px',
    },
    warningMessage: {
        color: tokens.colorStatusWarningForeground3,
        marginTop: '8px',
        fontSize: tokens.fontSizeBase200,
    },
});
